<app-header></app-header>
<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="info-section">
              <h3>
                {{ "cookie_policy.title" | translate }}
                <!-- GYB REMOVIA TOOL Cookie Policy -->
              </h3>
              <p [innerHTML]="'cookie_policy.intro' | translate">
                <!-- This Cookie Policy explains how GYB REMOVIA TOOL ("we," "us," or
                "our") uses cookies and similar tracking technologies when you
                visit our website
                <a href="https://removia.io/">https://removia.io/</a>. It
                explains what these technologies are, why we use them, and your
                choices regarding their use. -->
              </p>
              <p>
                {{ "cookie_policy.consent_notice" | translate }}
                <!-- By using our Site, you consent to the use of cookies as
                described in this policy. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{
                  "cookie_policy.sections.what_are_cookies.title" | translate
                }}
                <!-- 1. What Are Cookies? -->
              </h5>
              <p>
                {{ "cookie_policy.sections.what_are_cookies.text" | translate }}
                <!-- Cookies are small text files stored on your device (computer,
                smartphone, or tablet) by your web browser when you visit
                websites. Cookies help websites recognize your device and
                remember information about your visit, such as your preferences
                or login status. Cookies can be "first-party" (set by the
                website you are visiting) or "third-party" (set by other
                websites or services, such as advertisers or analytics
                providers). -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.types.title" | translate }}
                <!-- 2. Types of Cookies We Use -->
              </h5>
              <p>
                {{ "cookie_policy.sections.types.intro" | translate }}
                <!-- We use the following categories of cookies on our Site: -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                <h5>
                  {{
                    "cookie_policy.sections.types.necessary.title" | translate
                  }}
                </h5>
                <!-- 2.1 Necessary Cookies -->
              </h5>
              <p>
                {{ "cookie_policy.sections.types.necessary.text" | translate }}
                <!-- These cookies are essential for the operation of our Site and
                Services. They enable core functionalities such as security,
                network management, and accessibility. Without these cookies,
                certain parts of the Site may not function properly. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{
                  "cookie_policy.sections.types.analytical.title" | translate
                }}
                <!-- 2.2 Analytical/Performance Cookies -->
              </h5>
              <p>
                {{ "cookie_policy.sections.types.analytical.text" | translate }}
                <!-- These cookies collect information about how visitors use our
                Site, such as which pages are visited most often and if users
                encounter error messages. This data helps us improve the Site’s
                performance and user experience. The information collected is
                aggregated and anonymous. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{
                  "cookie_policy.sections.types.functionality.title" | translate
                }}
                <!-- 2.3 Functionality Cookies -->
              </h5>
              <p>
                {{
                  "cookie_policy.sections.types.functionality.text" | translate
                }}
                <!-- Functionality cookies remember choices you make on the Site
                (such as language or region) to provide a more personalized
                experience. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.types.marketing.title" | translate }}
                <!-- 2.4 Marketing/Advertising Cookies -->
              </h5>
              <p>
                {{ "cookie_policy.sections.types.marketing.text" | translate }}
                <!-- These cookies are used to deliver relevant advertisements to you
                based on your interests. They may also limit the number of times
                you see an ad and help measure the effectiveness of advertising
                campaigns. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.third_party.title" | translate }}
                <!-- 3. Third-Party Cookies -->
              </h5>
              <p>
                {{ "cookie_policy.sections.third_party.text" | translate }}
                <!-- We may allow third-party service providers to place cookies on
                your device to help us analyze Site usage, deliver
                advertisements, or provide other services. These third parties
                include, but are not limited to: -->
              </p>
              <ul>
                <li>
                  {{
                    "cookie_policy.sections.third_party.providers.google_analytics"
                      | translate
                  }}
                  <!-- Google Analytics -->
                </li>
                <li>
                  {{
                    "cookie_policy.sections.third_party.providers.google_ads"
                      | translate
                  }}
                  <!-- Google Ads -->
                </li>
                <li>
                  {{
                    "cookie_policy.sections.third_party.providers.facebook_pixel"
                      | translate
                  }}
                  <!-- Facebook Pixel -->
                </li>
                <li>
                  {{
                    "cookie_policy.sections.third_party.providers.cloudflare"
                      | translate
                  }}
                  <!-- Cloudflare -->
                </li>
                <li>
                  {{
                    "cookie_policy.sections.third_party.providers.other"
                      | translate
                  }}
                  <!-- Other advertising and analytics partners -->
                </li>
              </ul>
              <p>
                {{ "cookie_policy.sections.third_party.note" | translate }}
                <!-- These third parties have their own privacy policies and cookie
                management tools, which you can review independently. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.managing.title" | translate }}
                <!-- 4. Managing Cookies -->
              </h5>
              <p>
                {{ "cookie_policy.sections.managing.text" | translate }}
                <!-- Most web browsers automatically accept cookies, but you can
                usually modify your browser settings to decline cookies or alert
                you when cookies are being sent. Please note that if you disable
                or block cookies, some parts of our Site may not function
                properly or may be less personalized. -->
              </p>
              <p>
                {{ "cookie_policy.sections.managing.instructions" | translate }}
                <!-- For instructions on managing cookies in popular browsers, visit: -->
              </p>
              <ul>
                <li>
                  <a href="https://www.google.com/chrome/" target="_blank">
                    {{
                      "cookie_policy.sections.managing.browsers.chrome"
                        | translate
                    }}
                    <!-- Google Chrome -->
                  </a>
                </li>
                <li>
                  <a href="https://www.mozilla.org/en-US/" target="_blank">
                    {{
                      "cookie_policy.sections.managing.browsers.firefox"
                        | translate
                    }}
                    <!-- Mozilla Firefox -->
                  </a>
                </li>
                <li>
                  <a href="https://www.apple.com/safari/" target="_blank">
                    {{
                      "cookie_policy.sections.managing.browsers.safari"
                        | translate
                    }}
                    <!-- Safari -->
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.microsoft.com/uk-ua/edge/download?form=MA13FJ"
                    target="_blank"
                  >
                    {{
                      "cookie_policy.sections.managing.browsers.edge"
                        | translate
                    }}
                    <!-- Microsoft Edge -->
                  </a>
                </li>
              </ul>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.consent.title" | translate }}
                <!-- 5. Your Consent -->
              </h5>
              <p>
                {{ "cookie_policy.sections.consent.text" | translate }}
                <!-- By continuing to use our Site, you consent to our use of cookies
                as described in this Cookie Policy. Where required by law, we
                will seek your consent before placing non-essential cookies. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.updates.title" | translate }}
                <!-- 6. Updates to This Cookie Policy -->
              </h5>
              <p>
                {{ "cookie_policy.sections.updates.text" | translate }}
                <!-- We may update this Cookie Policy from time to time to reflect
                changes in our practices or legal requirements. We encourage you
                to review this page periodically for the latest information. -->
              </p>
            </div>
            <div class="info-section">
              <h5>
                {{ "cookie_policy.sections.contact.title" | translate }}
                <!-- 7. Contact Us -->
              </h5>
              <p>
                {{ "cookie_policy.sections.contact.intro" | translate }}
                <!-- If you have any questions about our use of cookies or this
                Cookie Policy, please contact us at: -->
              </p>
              <p>
                <b>
                  {{ "cookie_policy.sections.contact.email_label" | translate }}
                  <!-- Email:  -->
                </b>
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
              </p>
              <p>
                <b>
                  {{
                    "cookie_policy.sections.contact.address_label" | translate
                  }}
                  <!-- Address:  -->
                </b>
                {{ "cookie_policy.sections.contact.address" | translate }}
                <!-- GotYourBack Technologies Ltd., Spyrou Kyprianou
                61, SK House -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
